module.exports = __webpack_public_path__ + "static/media/comercial.f188b621.svg";